export const parseSearch = (input: string): Record<string, string> => {
  const output: Record<string, string> = {}

  // If the input string is empty, return an empty object
  if (input.trim() === '') {
    return output
  }

  // Remove any trailing commas or spaces and replace consecutive spaces with a single space
  input = input.trim().replace(/^,|,$/g, '').replace(/\s+/g, ' ')

  // If the input contains commas, split the string while preserving quoted strings
  if (input.includes(',')) {
    const parts = input.match(
      /(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|(?:[^,\s]+(?: [^,\s]+)*))/g,
    )

    if (parts) {
      parts.forEach((part, index) => {
        // Remove surrounding quotes if present
        const unquotedPart = part.replace(/^(['"])(.*)\1$/, '$2')
        output[index.toString()] = unquotedPart
      })
    }
  } else {
    // If the input doesn't contain commas, treat the entire string as a single part
    output[0] = input
  }

  return output
}
